import { render } from "./side-menu.vue?vue&type=template&id=171c311b"
import script from "./side-menu.vue?vue&type=script&lang=js"
export * from "./side-menu.vue?vue&type=script&lang=js"

import "./side-menu.vue?vue&type=style&index=0&id=171c311b&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__